const paramsToIgnore = [
    'elqTrackId',
    'elq',
    'elqaid',
    'elqat',
    'elqCampaignId',
    'elqak'
];

export function cleanURLParams() {
    const url = new URL(window.location.href);
    let changed = false;

    paramsToIgnore.forEach(param => {
        if (url.searchParams.has(param)) {
            url.searchParams.delete(param);
            changed = true;
        }
    });

    if (changed) {
        const newUrl = url.pathname + url.search + url.hash;
        window.history.replaceState({}, '', newUrl);
    }
}